import AccountCache from './cache';

const accountCache = new AccountCache();

const getAccountId = () => accountCache.getId();

// eslint-disable-next-line import/prefer-default-export
export { getAccountId };
